import React, { forwardRef } from "react";

import { concatClassNames } from "../../utils/styles";
import { icons } from "./ButtonPrimary";
import { Clickable } from "./Clickable";
import { ConditionalIcons } from "./ConditionalIcons";
import { ClickableProps } from "./types";

import styles from "./ButtonSecondary.module.scss";

export const ButtonSecondary = forwardRef<
    HTMLButtonElement | HTMLAnchorElement,
    ClickableProps
>(function ButtonSecondary(props, ref) {
    return (
        <Clickable
            {...props}
            ref={ref}
            className={concatClassNames([
                styles.secondaryButton,
                props.className ?? undefined,
            ])}
        >
            {props.children}
            <ConditionalIcons {...props} mappedConditionalIcons={icons} />
        </Clickable>
    );
});
